import { messages } from '../../i18n/messages/messages';
import { LOCALE } from '../typescript';

export function toSelectOption(option: any, locale: LOCALE | string = 'ar', name = 'label') {
  return {
    ...option,
    label: messages[locale][`${[option[name]]}`] || '-.-',
  };
}
